// frontend/src/main/AddStudiokw.js

import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Link, useParams } from 'react-router-dom'
import Nome from './FormFields/Nome'
import Email from './FormFields/Email'
import Motori from './FormFields/Motori'
import Domini from './FormFields/Domini'
import Brand from './FormFields/Brand'
import Industry from './FormFields/Industry'
import Mobile from './FormFields/Mobile'
import Authority from './FormFields/Authority'
import File from './FormFields/File'
import Validity from './FormFields/Validity'
import Volume from './FormFields/Volume'
import Formula from './FormFields/Formula'
import FormulaMonth from './FormFields/FormulaMonth'
import AiOverview from './FormFields/AiOverview'
import ShortReport from './FormFields/ShortReport'
import MultiplePositioning from './FormFields/MultiplePositioning'
import LocationName from './FormFields/LocationName'
import Description from './FormFields/Description'
import { notify } from '../utils/notify'
import { api } from '../utils/index'
import { useFetch, useFileUpload } from '../hooks'
import WModal from "../components/molecules/WModal";
import CharCheckModal from "../components/molecules/CharCheckModal";
import SetTitle from '../utils/set_title'
import BrandSuggestionModal from '../components/molecules/BrandSuggestionModal'
import { buildBrandSuggestions } from '../utils/brandUtils'
import {
	Button,
	Card,
	CardHeader,
	CardBody,
	Form,
	Row,
	Col
} from "reactstrap";
import Header from '../components/Headers/Header'
import DepthSelector from "./FormFields/DepthSelector";

const AddContext = React.createContext()

export default function AddStudiokw() {
	SetTitle('Add StudioKeyword')
	// Parametri fields
	const [name, setName] = useState('')
	const [emails, setEmails] = useState([])
	const [domini, setDomini] = useState([])
	const [brand, setBrand] = useState('')
	const [industry, setIndustry] = useState('')
	const [mobile, setMobile] = useState(true)
	const [validity, setValidity] = useState(7)
	const [authority, setAuthority] = useState(false)
	const [file, setFile] = useState(null)
	const [fileName, setFileName] = useState('')
	const [link, setLink] = useState('')
	const [bigqueryLink, setBigqueryLink] = useState('')
	const [volume, setVolume] = useState('')
	const [formula, setFormula] = useState('FormulaStatica_ctr')
	const [month, setMonth] = useState('')
	const [depth, setDepth] = useState(10)
	const [multiplePositioning, setMultiplePositioning] = useState(false)
	const [bigQuery, setBigQuery] = useState(true)
	const [locationName, setLocationName] = useState('Correggio,Emilia-Romagna,Italy')
	const [term, setTerm] = useState('')
	const [locationFiltered, setLocationFiltered] = useState([])
	const [description, setDescription] = useState('')
	const [allBrand, setAllBrand] = useState([])
	const [aiOverview, setAiOverview] = useState(false)
	const [showBrandCheck, setShowBrandCheck] = useState(false)
	const [brandSuggestions, setBrandSuggestions] = useState([])
	const [pendingSubmitType, setPendingSubmitType] = useState(null)
	const [brandGuarded, setBrandGuarded] = useState(false)
 	const { upload: uploadAndEvaluate, loading: isEvaluating } = useFileUpload()

	useEffect(() => {
		setBrandGuarded(false)
	}, [brand])

  	let history = useHistory()

	// Recupero location names da backend
	const { data: dataLocationNames } = useFetch({ url: 'location-names/' })

	// New state for engine and locale
	const [engine, setEngine] = useState('');
	const [locale, setLocale] = useState('');
	const [allMotori, setAllMotori] = useState([]);
	const [engines, setEngines] = useState([]);
	const [locales, setLocales] = useState([]);
	const [motoreRicercaId, setMotoreRicercaId] = useState(null);

	// url param
	let { id: studioKwID } = useParams()
	// studioKw detail
	const [studioKwDetail, setStudioKwDetail] = useState({})

	// Recupero formula serpy da backend
	const [formulas, setFormulas] = useState([])
	const [formulaMonths, setFormulaMonths] = useState({})
	const [formulaAll, setFormulaAll] = useState({})
	// Modal e costi da mostrare
	const [show, setShow] = useState(false)
	const [price, setPrice] = useState({ min: 0, max: 0 })
	// Modal check caratteri
	const [showCharCheck, setShowCharCheck] = useState(false)
	const [errCharList, setErrCharList] = useState([])
	const [acceptedCharCheck, setAcceptedCharCheck] = useState(false)

	const getFormulas = () => {
		api
			.get('formulas-serpy/')
			.then((res) => {
				const cache = {}
				res.data.forEach((f) => {
					if (cache.hasOwnProperty(f.category)) {
						cache[f.category].push(f.giorno.split('T')[0])
					} else cache[f.category] = [f.giorno.split('T')[0]]
				})
				setFormulas(Object.keys(cache))
				setFormulaMonths(cache)
				setFormulaAll(res.data)
			})
			.catch((err) => {
				console.error(err)
				notify('Errore nel caricamento formule da Serpy', 'error')
			})
	}

	const getStudioKwDetail = (id) => {
		api
			.get(`studiokw/${id}/`)
			.then((response) => {
				setStudioKwDetail(response)
			})
			.catch((error) => console.error(error))
	}

	const getAllBrand = () => {
		api
			.get(`get_all_brand/`)
			.then((response) => {
				setAllBrand(response.data)
			})
			.catch((error) => console.error(error))
	}

	const filterLocationNames = (nameSearched = '') => {
		if (!!dataLocationNames && nameSearched.length > 2) {
			let list = dataLocationNames.filter(
				(location) => location.toLowerCase().includes(nameSearched.toLowerCase()) === true
			)
			setLocationFiltered(list)
		}
	}

	const promptBrandSuggestions = (submitType) => {
		const suggestions = buildBrandSuggestions(brand, allBrand)
		setBrandSuggestions(suggestions)
		if (suggestions.length > 0) {
			setPendingSubmitType(submitType)
			setShowBrandCheck(true)
			return true
		}
		setBrandGuarded(true)
		return false
	}

	const proceedWithBrandSelection = (selectedBrand) => {
		const submitType = pendingSubmitType
		setShowBrandCheck(false)
		setPendingSubmitType(null)

		if (selectedBrand) {
			setBrand(selectedBrand)
			setBrandGuarded(true)
		}

		if (submitType === "create") {
			handleSubmit(null, true, selectedBrand ?? brand)
		} else if (submitType === "update") {
			updateStudioKW(null, true, selectedBrand ?? brand)
		} else if (submitType === "fileEval") {
			fileEvaluation(null, true, selectedBrand ?? brand)
		}
	}

	useEffect(() => {
		api.get('motori-ricerca/').then(res => setAllMotori(res.data));
		api.get('motori-ricerca/aziende/').then(res => setEngines(res.data));
		getFormulas()
		getAllBrand()
	}, [])

	useEffect(() => {
		studioKwID && getStudioKwDetail(studioKwID)
	}, [studioKwID])

	useEffect(() => {
		if (engine) {
			api.get(`motori-ricerca/locales/?azienda=${engine}`).then(res => {
				setLocales(res.data);
				if (!res.data.includes(locale)) {
						setLocale('');
				}
			});
		} else {
			setLocales([]);
			setLocale('');
		}
	}, [engine]);

	useEffect(() => {
		if (engine && locale && allMotori.length > 0) {
				const motore = allMotori.find(m => m.azienda === engine && m.locale === locale);
				setMotoreRicercaId(motore ? motore.id : null);
		} else {
				setMotoreRicercaId(null);
		}
	}, [engine, locale, allMotori]);

  	useEffect(() => {
		if (Object.keys(studioKwDetail).length !== 0 && allMotori.length > 0) {
			const {
				nome,
				brand,
				email,
				motore_ricerca,
				domini,
				industry,
				mobile,
				day_delta,
				authority_labs,
				file,
				file_name,
				link,
				bigquery_link,
				volume_column,
				formula_json,
				serp_depth,
				multiple_positioning,
				export_to_bigquery,
				description,
				location_name,
				term,
				ai_overview,
			} = studioKwDetail?.data

			const motore = allMotori.find((m) => m.id === motore_ricerca)
			if (motore) {
				setEngine(motore.azienda);
				setLocale(motore.locale);
			}

			let dateMese = formula_json.giorno.toString().split('T')[0]
			setName(window.location.pathname.includes('duplicate') ? `${nome} - COPIA` : nome)
			setBrand(brand)
			setEmails(email.split(',') )
			setDomini(domini.split(','))
			setDescription(description)
			setLocationName(location_name)
			setTerm(term)
			setIndustry(industry)
			setMobile(mobile ? true : false)
			setValidity(day_delta)
			setAuthority(authority_labs)
			setFile(file)
			setFileName(file_name)
			setLink(link)
			setBigqueryLink(bigquery_link)
			setVolume(volume_column)
			setFormula(formula_json.category)
			setMonth(dateMese)
			setDepth(serp_depth)
			setMultiplePositioning(multiple_positioning)
			setBigQuery(export_to_bigquery)
			setAiOverview(ai_overview || false)
		}
	}, [studioKwDetail, allMotori])

	const handleFileSelection = (selectedFile) => {
		if (selectedFile) {
			setFile(selectedFile);
			setFileName(selectedFile.name);
		} else {
			setFile(null);
			setFileName('');
		}
	};

	useEffect(() => {
		// Se ho la lista dei mesi delle formule, procedo
		Object.keys(formulaMonths).length > 0 && !studioKwID && setMonth(formulaMonths[formula][0])
	}, [formula, formulaMonths])

	const handleClear = () => {
		setName('')
		setEmails([])
		setEngine('')
		setLocale('')
		setMotoreRicercaId(null)
		setDomini([])
		setBrand('')
		setIndustry('')
		setMobile(true)
		setValidity(7)
		setAuthority(false)
		setFile(null)
		setFileName('')
		setLink('')
		setBigqueryLink('')
		setVolume('')
		setFormula('FormulaStatica_ctr')
		setMonth('')
		setDepth(10)
		setMultiplePositioning(false)
		setBigQuery(true)
		setLocationName('')
		setTerm('')
		setDescription('')
		setEmails([])
		setDomini([])
		setAiOverview(false)
	}

	const handleSubmit = (e, skipBrandGuard = false, brandOverride = null) => {
		e && e.preventDefault()

		if (!motoreRicercaId) {
			notify('Selezionare un motore e un locale validi.', 'error');
			return;
		}

		if (!skipBrandGuard && !brandGuarded && promptBrandSuggestions("create")) {
			return
		}
		const brandValue = brandOverride ?? brand
		if (brandOverride) {
			setBrand(brandOverride)
			setBrandGuarded(true)
		}

		let formData = new FormData()
		formData.append('nome', name)
		formData.append('file_name', file?.name ? file.name : fileName)
		formData.append('day_delta', validity)
		formData.append('motore_ricerca', motoreRicercaId)

		let f = formulaAll.find((f) => f.category === formula && f.giorno.split('T')[0] === month)
		if (formula === "FormulaStatica_ctr" || formula === "FormulaStatica_StimeAumentoTraffico") {
			f = formulaAll.find((f) => f.category === formula)
		}
		formData.append('formula_json', JSON.stringify(f))

		formData.append('mobile', mobile)
		formData.append('serp_depth', depth)
		formData.append('authority_labs', authority)
		formData.append('multiple_positioning', multiplePositioning)
		formData.append('export_to_bigquery', bigQuery)
		brandValue && formData.append('brand', brandValue)
		industry && formData.append('industry', industry)
		formData.append('country', locale)
		formData.append('description', description)
		formData.append('volume_column', volume ? volume : 'Volume')
		formData.append('location_name', locationName)
		formData.append('term', term)
		formData.append('email', emails)
		formData.append('domini', domini)
		file && formData.append('file', file ?? null)
		formData.append('ai_overview', aiOverview)

		api
			.post('studiokw/', formData, {
				headers: { 'Content-Type': 'multipart/form-data' },
			})
			.then((response) => {
				if (response.status === 201) {
					history.push('/')
				} else {
					notify(
						'Non è stato possibile creare lo studiokw, riprovare o contattare un Innovation',
						'error'
					)
				}
			}, (err) => {
				let res = err.response
				if (res.status <= 500) {
					notify(
						res.data.message,
						'error'
					)
				} else {
					notify(
						'Non è stato possibile creare lo studiokw, riprovare o contattare un Innovation',
						'error'
					)
				}
			})
	}

	const updateStudioKW = (e, skipBrandGuard = false, brandOverride = null) => {
		e && e.preventDefault()

		if (!motoreRicercaId) {
			notify('Selezionare un motore e un locale validi.', 'error');
			return;
		}

		if (!skipBrandGuard && !brandGuarded && promptBrandSuggestions("update")) {
			return
		}
		const brandValue = brandOverride ?? brand
		if (brandOverride) {
			setBrand(brandOverride)
			setBrandGuarded(true)
		}

		let f = formulaAll.find((f) => f.category === formula && f.giorno.split('T')[0] === month)
		if (formula === "FormulaStatica_ctr" || formula === "FormulaStatica_StimeAumentoTraffico") {
			f = formulaAll.find((f) => f.category === formula)
		}
		let update_data = {
			...studioKwDetail.data,
			"nome": name,
			"brand": brandValue,
			"country": locale,
			"industry": industry,
			"domini": domini.toString(),
			"email": emails.toString(),
			"mobile": mobile,
			"description": description,
			"multiple_positioning": multiplePositioning,
			"day_delta": validity,
			"volume_column": volume,
			"formula_json": f,
			"serp_depth": depth,
			"authority_labs": authority,
			"location_name": locationName,
			"term":term,
			"export_to_bigquery": bigQuery,
			"file_output_name": fileName,
			"ai_overview": aiOverview,
			"motore_ricerca": motoreRicercaId,
		}

		delete update_data.file
		delete update_data.file_output

		api.patch('studiokw/' + studioKwID + '/', update_data, {
			headers: { 'Content-Type': 'application/json' },
		})
			.then((response) => {
				if (response.status === 200) {
					notify('Modifiche applicate con successo.', 'success')
					history.push('/')
				}
			},
				(err) => {
					notify(
						err.message,
						'error'
					)
				})
	}

	const getStudioKwCosts = (filename) => {
		api.post('get-studiokw-cost/', { filename: filename, ai_overview: aiOverview, serp_depth: depth }, {
			headers: { 'Content-Type': 'application/json' },
		}).then((res) => {
			if (res.status >= 400) {
				throw new Error('Impossibile recuperare i dati di costo')
			}
			return res.data
		}).then(
			(data) => {
				setPrice({ min: data.cost_min, max: data.cost_max })
				setShow(true)
			},
			(err) => {
				notify(err.message, 'warning')
			}
		)
	}

  const uploadFile = async () => {
    let formData = new FormData()
    formData.append('volume_column', volume ? volume : 'Volume')
    file && formData.append('file', file)
    acceptedCharCheck && formData.append('accepted', acceptedCharCheck)

    const endpoint = 'studiokw/upload_file/'

    try {
      const filename = await uploadAndEvaluate('post', endpoint, formData)
      setFileName(filename)
      getStudioKwCosts(filename)
    } catch (err) {
      if (err.response?.data?.message?.includes('ERROR Encoding keywords')) {
        setErrCharList(err.response.data?.errors)
        setShowCharCheck(true)
      }
      setShow(false)
    }
  }

	const fileEvaluation = async (e, skipBrandGuard = false, brandOverride = null) => {
		if (e)
			e.preventDefault()

		const brandValue = brandOverride ?? brand
		if (brandOverride) {
			setBrand(brandOverride)
		}

		if (!skipBrandGuard && !brandGuarded && promptBrandSuggestions("fileEval")) {
			return
		}
		setBrandGuarded(true)

		try {
			const filename = await uploadFile();
			if (filename) {
				getStudioKwCosts(filename)
			}
		} catch (err) {
			setShow(false)
			console.error("File evaluation failed:", err)
		}
	}
	const confirmEvaluation = (e) => {
		e.preventDefault()
		setShowCharCheck(false)
		setAcceptedCharCheck(true)
	}

	useEffect(() => {
		if(acceptedCharCheck) {
			fileEvaluation(null, false, brand)
		}
	}, [acceptedCharCheck])

	return (
		<>
      <Header iconClass="fa-solid fa-house-chimney fa-xl" title="Rank Inspector" />
			<Row>
				<Col style={{display: "flex", justifyContent: "center"}}>
					<Card style={{ marginTop: '+3em', maxWidth:'1200px', marginBottom: "150px" }} className="bg-secondary shadow">
						<CardHeader className="bg-white border-0">
							<Row className="align-items-center">
								<Col md={10}>
									<h1> Add StudioKeyword </h1>
								</Col>
								<Col md={2} style={{textAlign: "right"}}>
									<Button color="warning" onClick={() => history.push('/')}>&#60; Go Back</Button>
								</Col>
							</Row>
						</CardHeader>
						<CardBody className="pt-0 pt-md-4">
							<div id="AddStudiokw">
								<CharCheckModal show={showCharCheck} onHide={setShowCharCheck} onSubmit={confirmEvaluation} errCharList={errCharList} />
								<BrandSuggestionModal
									show={showBrandCheck}
									onHide={() => setShowBrandCheck(false)}
									suggestions={brandSuggestions}
									onSelect={(selected) => proceedWithBrandSelection(selected)}
									onKeepNew={() => proceedWithBrandSelection(null)}
									newBrand={brand}
								/>
								<WModal show={show} onHide={setShow} cost={price} onSubmit={() => handleSubmit(null, true)} />
								<Form onSubmit={ studioKwID && !window.location.pathname.includes('duplicate') ? updateStudioKW : typeof(file)=='string' ? handleSubmit : fileEvaluation }>
									<AddContext.Provider
										value={{
											name: name,
											setName: setName,
											emails: emails,
											setEmails: setEmails,
											engine,
											setEngine,
											engines,
											locale,
											setLocale,
											locales,
											domini: domini,
											setDomini: setDomini,
											industry: industry,
											setIndustry: setIndustry,
											mobile: mobile,
											setMobile: setMobile,
											validity: validity,
											setValidity: setValidity,
											authority: authority,
											setAuthority: setAuthority,
											file: file,
											fileName: fileName,
											link: link,
											handleFileSelection: handleFileSelection,
											volume: volume,
											setVolume: setVolume,
											formula: formula,
											setFormula: setFormula,
											formulas: formulas,
											formulaMonths: formulaMonths,
											month: month,
											setMonth: setMonth,
											depth: depth,
											setDepth: setDepth,
											multiplePositioning: multiplePositioning,
											setMultiplePositioning: setMultiplePositioning,
											bigQuery: bigQuery,
											setBigQuery: setBigQuery,
											locationName: locationName,
											setLocationName: setLocationName,
											term: term,
											setTerm: setTerm,
											filterLocationNames: filterLocationNames,
											locationFiltered: locationFiltered,
											setDescription: setDescription,
											description: description,
											brand: brand,
											setBrand: setBrand,
											allBrand: allBrand,
											aiOverview: aiOverview,
											setAiOverview: setAiOverview
										}}
									>
										<h6 className="heading-small text-muted mb-4">
											Info Base
										</h6>
										<Row>
											<Col xs={12} md={6}>
												<Nome context={AddContext} />
											</Col>
											<Col xs={12} md={6}>
												<Email context={AddContext} />
											</Col>
										</Row>
										<Row>
											<Col xs={12} md={12}>
												<Motori context={AddContext} />
											</Col>
										</Row>
										<Row>
											<Col xs={12} md={12}>
												<Domini context={AddContext} />
											</Col>
										</Row>
										<Row>
											<Col xs={12} md={6}>
												<Brand context={AddContext} />
											</Col>
											<Col xs={12} md={6}>
												<Industry context={AddContext} />
											</Col>
										</Row>
										<Row>
											<Col xs={12} md={5}>
												<LocationName context={AddContext} />
											</Col>
											<Col md="auto"></Col>
											<Col xs={12} md={6}>
												<Description context={AddContext} />
											</Col>
										</Row>
										<hr className="my-4"></hr>
										<h6 className="heading-small text-muted mb-4">
											SERP
										</h6>
										<Row>
											<Col xs={12} md={6}>
												<Mobile context={AddContext} />
											</Col>
											<Col xs={12} md={6}>
												<Validity context={AddContext} />
											</Col>
										</Row>
										<Row>
											<Col xs={12} md={6}>
												<Formula context={AddContext} />
											</Col>
											<Col xs={12} md={6}>
												<FormulaMonth context={AddContext} />
											</Col>
										</Row>
										<hr className="my-4"></hr>
										<h6 className="heading-small text-muted mb-4">
											IMPORT
										</h6>
										<Row>
											<Col xs={12} md={6}>
												<Volume context={AddContext} />
											</Col>
											<Col xs={12} md={6}>
												<File context={AddContext} />
											</Col>
										</Row>
										<hr className="my-4"></hr>
										<h6 className="heading-small text-muted mb-4">
											EXPORT
										</h6>
										<Row>
											<Col xs={12} md={6}>
												<DepthSelector context={AddContext} />
											</Col>
											<Col xs={12} md={6}>
                        <AiOverview context={AddContext} />
                      </Col>
										</Row>
										<Row>
											<Col xs={12} md={6}>
												<MultiplePositioning context={AddContext} />
											</Col>
										</Row>
										{(bigqueryLink && bigqueryLink.length > 0) ?
											<Row>
												<Col xs={12} md={6}>
													<a href={bigqueryLink} target="_blank" rel="noopener noreferrer">Link a RAW_Export (Bigquery)</a>
												</Col>
											</Row>
										: null}
										<Row style={{ marginBottom: '3%', marginTop: '3%' }}>
											<Col xs={12} md={2}>
												<Link to="/home">
													<Button style={{ width: '100%' }}>Back</Button>
												</Link>
											</Col>
											<Col xs={12} md={4} />
											<Col xs={12} md={2}>
												<Button style={{ width: '100%' }} onClick={handleClear}>
													Clear
												</Button>
											</Col>
											<Col xs={12} md={4}>
											<Button color="info" size="lg" >Submit Report</Button>
											</Col>
										</Row>
									</AddContext.Provider>
								</Form>
							</div>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</>
	)
}
